<template>
  <div class="unstyledwrapper">
    <div :class="'renderItem book'+controlid" :id="'book'+controlid">
      <div class="book-action-mobile">
        <div class="img-area">
          <img
            :src=" signedHost + '/.netlify/functions/api/thumbnails/' + $attrs.bookDOI + '/thumbnails/1.jpg'"
            alt="Book Cover"
            class="book-image"
          />
        </div>
        <div class="button-area-line">
          <a
            target="_blank"
            name="mybutton"
            id="myButton"
            @click="show_dialog('modal' + controlid,'navigate' + controlid, $attrs.chapterDOI)"
            class="open"
          > Open This Chapter</a>
          <a
            target="_blank"
            @click="show_dialog('modal' + controlid,'navigate' + controlid, $attrs.bookDOI)"
            class="open"
          >Open Book</a>
        </div>
      </div>
      <div class="book-header">
        <h1>{{ $attrs.bookTitle }}, chapter {{$attrs.chapterNo}}: {{ $attrs.chapterTitle }}</h1>
      </div>
      <div class="book-content" key="$attrs._id">
        <div class="mobile-hide">
          <!-- <img :src="'https://janssen-onco-lib.s3.eu-west-2.amazonaws.com/' + $attrs.bookDOI + '/thumbnails/1.jpg'" alt="Book Cover" class="book-image" /> -->
          <img
            :src=" signedHost + '/.netlify/functions/api/thumbnails/' + $attrs.bookDOI + '/thumbnails/1.jpg'"
            alt="Book Cover"
            class="book-image"
          />
        </div>
        <div class="column justify-top ml20 infopanel">
          <div class="bookPanelDescription">
            <span class="bookLabel">Book:&nbsp;</span>
            <span class="bookInfo">{{ $attrs.bookTitle }}</span>
          </div>
          <div class="bookPanelDescription">
            <span class="bookLabel">Published:&nbsp;</span>
            <span class="bookInfo">{{ $attrs.bookPublishedYear }}</span>
          </div>
          <div class="bookPanelDescription">
            <span class="bookLabel">Authors:&nbsp;</span>
            <span
              v-for="(creator, index) in $attrs.chapterExperts"
              class="bookInfo"
              :key="index"
            >{{creator.creator}},</span>
          </div>
          <div class="bookPanelDescription">
            <span class="bookLabel">Abstract:&nbsp;</span>
            <span class="bookInfo">{{ $attrs.chapterAbstract }}</span>
          </div>
          <div class="button-area-line mobile-hide">
            <a
              target="_blank"
              name="mybutton"
              id="myButton"
              @click="show_dialog('modal' + controlid,'navigate' + controlid, $attrs.chapterDOI)"
              class="open"
            >Open This Chapter</a>
            <a
              target="_blank"
              @click="show_dialog('modal' + controlid,'navigate' + controlid, $attrs.bookDOI)"
              class="open"
            >Open Book</a>

            <!-- <a target="_blank" name="mybutton" id="myButton" @click="show_dialog('modal'+controlid,'navigate'+controlid, 'https://janssen-onco-lib.s3.eu-west-2.amazonaws.com/' + $attrs.chapterDOI + '/index.html') "  class="open">Open This Chapter</a>
            <a target="_blank" @click="show_dialog('modal'+controlid,'navigate'+controlid,'https://janssen-onco-lib.s3.eu-west-2.amazonaws.com/' + $attrs.bookDOI + '/index.html')" class="open">Open Book</a>-->
          </div>
        </div>
      </div>
      <!-- Modal -->
      <div
        class="modal fade"
        :id="'modal'+this.controlid"
        tabindex="-1"
        role="dialog"
        aria-labelledby="dialog_confirm_mapLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-body text-center">
              <p class="text-center pt-4">
                You are leaving Janssen Medical Cloud to navigate to an external website. We
                invite you to read its Privacy Policy
              </p>
            </div>
            <div class="modal-footer justify-content-center align-items-center">
              <button
                type="button"
                :id="'navigate'+this.controlid"
                class="btn btn-primary"
                data-dismiss="modal"
                @click="orderBook()"
              >I AGREE</button>
              <button type="button" class="btn btn-cancel" data-dismiss="modal">CANCEL</button>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    console.log("NODE_ENV", process.env.NODE_ENV);
    return {
      props: ["bookprops"],
      //item: {},
      checked: false,
      controlid: this._uid,
      signedHost:
        process.env.NODE_ENV === "development" ? "http://localhost:9000" : ""
      //   chapterUrl:'https://janssen-onco-lib.s3.eu-west-2.amazonaws.com/' + $attrs.chapterDOI + '/index.html',
      //   bookUrl: 'https://janssen-onco-lib.s3.eu-west-2.amazonaws.com/' + $attrs.bookDOI + '/index.html'
    };
  },
  methods: {
    orderBook: function() {
      document.cookie = `BookID=${this.bookId};samesite=none;secure=true`;
      console.log('testing', document.cookie)
      window.open(this.navigateTo);
    },
    gtmTrackEvent (category, label, value, action='click', event=null) {
      this.$gtm.trackEvent({
      	event: event, // Event type [default = 'interaction'] (Optional)
      	category: category,
      	action: action,
      	label: label,
      	value: value,
      })
    },
    trackGtmEvent (bookId) {
      if (bookId === this.$attrs.bookDOI) {
        const category = 'Button press'
        const label = this.$attrs.bookTitle
        const action = 'Open Book - ' + this.$attrs.bookDOI
        const value = null

        // Todo: event track for order a book
        this.gtmTrackEvent(category, label, value, action)
      } else if (bookId === this.$attrs.chapterDOI) {
        const category = 'Button press'
        const label = this.$attrs.chapterTitle
        const action = 'Open Chapter - ' + this.$attrs.chapterDOI
        const value = null

        // Todo: event track for order a chapter
        this.gtmTrackEvent(category, label, value, action)
      }
    },
    show_dialog: function(divToCover, actionButtonId, bookId) {
      $("#" + divToCover).modal("show");
      $(".modal-backdrop").appendTo("#book" + this.controlid);
      this.bookId = bookId;
      this.trackGtmEvent(bookId)
      this.navigateTo = `${this.signedHost}/.netlify/functions/api/open/${bookId}`;
      //removing body classes to able click events
      $("body").removeClass("modal-open");
    },
    mounted() {
      this.controlid = this._uid;
    }
  }
};
</script>
